import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuideSectionLabel,
  GuideCard,
  GuideCardGrid,
  GuideBlockList,
} from "../GuideBlocks.js";

const EmotionalRegulationSection = ({ heading, accentIndex = 1, getVisual, getAccent }) => (
  <GuidePanel
    sectionId="emotional-regulation"
    heading={heading}
    accentIndex={accentIndex}
    getVisual={getVisual}
    getAccent={getAccent}
  >
    <GuideLead>
      Emotions are information. Being controlled by emotions is exhausting. Emotional regulation
      means managing emotions without suppressing them.
    </GuideLead>
    <p className="guide-panel__p">
      It allows you to experience difficult feelings while choosing deliberate actions. In practice,
      regulation is a delay: the emotion arrives first, the response waits until the interpretation
      behind it has been named and checked against the facts.
    </p>
    <GuideSectionLabel>Practical ways to regulate emotions</GuideSectionLabel>
    <GuideCardGrid columns={2}>
      <GuideCard
        iconKey="awareness"
        title="Pause before responding"
        description="A few moments of silence can prevent hours of regret."
      />
      <GuideCard iconKey="energy" title="Notice early reaction signals">
        <GuideBlockList
          items={[
            "Rehearsing a comeback mid-conversation",
            "Re-reading a message for hidden meaning",
            "Urge to reply immediately",
            "Replaying the moment on loop",
          ]}
        />
      </GuideCard>
      <GuideCard iconKey="thinking" title="Challenge automatic thoughts">
        <GuideBlockList
          items={[
            "Is this thought true?",
            "What evidence supports it?",
            "Is there another explanation?",
          ]}
        />
      </GuideCard>
      <GuideCard
        iconKey="clarity"
        title="Choose helpful actions"
        description='Ask yourself, "What action will help me tomorrow, not just today?"'
      />
    </GuideCardGrid>
    <GuideCallout variant="amber">
      Regulation is not about avoiding emotions. It is about responding deliberately.
    </GuideCallout>
  </GuidePanel>
);

export default EmotionalRegulationSection;
